import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  CircularProgress,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";

const UserForm = ({
  open,
  handleClose,
  isEditing,
  selectedUser,
  onSubmit,
  loginUserData,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    if (isEditing && selectedUser) {
      reset({
        full_name: selectedUser.full_name || "",
        contact: selectedUser.contact || "",
        email: selectedUser.email || "",
        user_name: selectedUser.user_name || "",
        password: "", // leave blank for editing
        confirm_password: "", // leave blank for editing
        role_id: selectedUser.role_id || "",
        status: selectedUser.status || "1",
      });
    }
  }, [isEditing, selectedUser, reset]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {isEditing ? "Edit User" : "Add User"}
        <Button
          onClick={handleClose}
          color="secondary"
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            padding: "0 10px",
          }}
        >
          Close
        </Button>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextField
            label="Full Name"
            variant="outlined"
            fullWidth
            margin="dense"
            size="small"
            {...register("full_name", { required: "This field is required." })}
            error={!!errors.full_name}
            helperText={errors.full_name?.message}
          />
          <TextField
            label="Phone"
            variant="outlined"
            fullWidth
            margin="dense"
            size="small"
            {...register("contact", { required: "This field is required." })}
            error={!!errors.contact}
            helperText={errors.contact?.message}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="dense"
            size="small"
            {...register("email", { required: "This field is required." })}
            error={!!errors.email}
            helperText={errors.email?.message}
          />
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="dense"
            size="small"
            {...register("user_name", { required: "This field is required." })}
            error={!!errors.user_name}
            helperText={errors.user_name?.message}
          />
          {!isEditing && (
            <>
              <TextField
                label="Password"
                variant="outlined"
                fullWidth
                margin="dense"
                type="password"
                size="small"
                {...register("password", {
                  required: "This field is required.",
                })}
                error={!!errors.password}
                helperText={errors.password?.message}
              />
              <TextField
                label="Confirm Password"
                variant="outlined"
                fullWidth
                margin="dense"
                type="password"
                size="small"
                {...register("confirm_password", {
                  required: "This field is required.",
                })}
                error={!!errors.confirm_password}
                helperText={errors.confirm_password?.message}
              />
            </>
          )}
          <FormControl
            fullWidth
            margin="dense"
            size="small"
            error={!!errors.role_id}
          >
            <InputLabel>User Type</InputLabel>
            <Select
              label="User Type"
              {...register("role_id", { required: "Please select a role." })}
              defaultValue={selectedUser?.role_id || ""}
            >
              <MenuItem value={1}>Admin</MenuItem>
              <MenuItem value={2}>Manager</MenuItem>
              <MenuItem value={3}>Employee</MenuItem>
            </Select>
            <FormHelperText>{errors.role_id?.message}</FormHelperText>
          </FormControl>
          <FormControl
            fullWidth
            margin="dense"
            size="small"
            error={!!errors.status}
          >
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              {...register("status", { required: "Please select a status." })}
              defaultValue={selectedUser?.status || "1"}
            >
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Inactive</MenuItem>
            </Select>
            <FormHelperText>{errors.status?.message}</FormHelperText>
          </FormControl>
        </form>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Button
          type="submit"
          onClick={handleSubmit(onSubmit)}
          disabled={isSubmitting}
          className="submitBTN"
        >
          {isSubmitting ? <CircularProgress size={24} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
